import dJSON from 'dirty-json';
import Splide from '@splidejs/splide';
import { setupSplide } from '../../../js/global';

const moduleSelector = '.tabbed-content';

/**
 * Module Init
 */
(() => {
  const modules = document.querySelectorAll(moduleSelector);
  if (!modules.length) return;

  modules.forEach((module) => {
    try {
      module.querySelector('script')?.remove(); // cleanup

      const { data } = dJSON.parse(module.data);
      const tabTabsContainer = module.querySelector('.tab__tabs');
      const tabContentContainer = module.querySelector('.tab__content');

      if (!tabTabsContainer || !tabContentContainer) return;

      const splides = [];

      // Create tabs and content for each item in the nested array
      data.forEach((item, index) => {
        const tabTitle = item['Tab Title'] || `Tab ${index + 1}`;
        const contentArray = item.Content || [];

        // Create tab button
        const tabButton = document.createElement('button');
        tabButton.className = 'tab__button';
        tabButton.textContent = tabTitle;
        tabButton.setAttribute('data-tab-index', index);
        if (index === 0) {
          tabButton.classList.add('is-active');
        }
        tabTabsContainer.appendChild(tabButton);

        // Create tab content wrapper
        const tabContentWrapper = document.createElement('div');
        tabContentWrapper.className = 'tab__content-item';
        tabContentWrapper.setAttribute('data-content-index', index);
        if (index === 0) {
          tabContentWrapper.classList.add('is-active');
        }

        // Create Splide structure
        const splideElement = document.createElement('div');
        splideElement.className = 'splide';
        splideElement.setAttribute('data-splide-index', index);

        const splideTrack = document.createElement('div');
        splideTrack.className = 'splide__track';

        const splideList = document.createElement('div');
        splideList.className = 'splide__list';

        // Add slides from content array
        contentArray.forEach((contentItem) => {
          const slide = document.createElement('div');
          slide.className = 'splide__slide';
          slide.innerHTML = /* html */ `
            <a href="${contentItem.Link || '#'}" class="slide-link">
              <img src="${contentItem.Image || ''}" alt="" />
              <button class="btn-custom secondary">Shop Now</button>
            </a>
          `;
          splideList.appendChild(slide);
        });

        splideTrack.appendChild(splideList);
        splideElement.appendChild(splideTrack);
        tabContentWrapper.appendChild(splideElement);
        tabContentContainer.appendChild(tabContentWrapper);

        // Store splide element for later initialization
        splides.push(splideElement);
      });

      // Add click handlers to tab buttons
      const tabButtons = tabTabsContainer.querySelectorAll('.tab__button');
      const tabContentItems = tabContentContainer.querySelectorAll('.tab__content-item');

      tabButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const tabIndex = parseInt(button.getAttribute('data-tab-index'), 10);

          // Remove is-active from all tabs and content
          tabButtons.forEach((btn) => btn.classList.remove('is-active'));
          tabContentItems.forEach((item) => item.classList.remove('is-active'));

          // Add is-active to clicked tab and corresponding content
          button.classList.add('is-active');
          tabContentItems[tabIndex]?.classList.add('is-active');
        });
      });

      // Initialize Splide for each carousel
      splides.forEach((splideElement) => {
        const slider = new Splide(splideElement, {
          type: 'loop',
          perPage: 5,
          perMove: 1,
          gap: 24,
          pagination: true,
          arrows: false,
          autoplay: false,
          breakpoints: {
            1200: {
              perPage: 3,
            },
            991: {
              perPage: 2,
            },
          },
        });
        setupSplide(slider);
        slider.mount();
      });
    } catch (error) {
      console.error(`Error: ${moduleSelector}`, error);
    }
  });
})();
